import { superAxios } from "./superAxios";
var OcelotService="OcelotService";

export enum ShopOrderStatusEmun {
  PendingPayment = 2141010, // 待付款
  TobeShipped = 2141040, // 待发货
  Shipped = 2141060, // 已发货
  Delivered = 2141080, //已签收
  Cancel = 2141090, //已取消
  RefundAndReturn = 2141100, //退款退货
  Completed = 2141110, //已完成
}
export interface OrdersPackagesDetailDto {
  orderDetailsId: string;
  quantity: number;
}

export interface CreatePackageDto {
  packageId: string;
  orderId: string;
  companyId: string;
  expressNo: string;
  remark: string;
  listOrdersPackagesDetailsDto: OrdersPackagesDetailDto[];
}

export interface ReturnOrderDetailsDto {
  orderDetailId: string;
  /**
   * 数量
   */
  quantity: number;
  /**
   * 退货理由  1少货 3尺寸不对 5破损
   */
  reasonId?: number;
  /**
   * 备注
   */
  remark?: string;
}

export interface ReturnOrderDto {
  /**
   * 订单号
   */
  orderId: string;
  customerId?: string;
  /**
   * 是否整单退
   */
  isFullOrderRefund: boolean;
  /**
   * 备注
   */
  remark?: string;
  returnOrderDetailsDto: ReturnOrderDetailsDto[];
}


 //我的订单状态状态数据
 export const GetListOrderStatusStatistics = async (params: any) => {
    
   const res = await (
     await superAxios.useWebAPI(OcelotService)
   ).getH({
     url: "app/OrderSystem/GetListOrderStatusStatistics",
     params
   });
    
   return res;
 };


 //订单列表
 export const Orderslist = async (params: any) => {
  
   const res = await (
     await superAxios.useWebAPI(OcelotService)
   ).getH({
     url: "app/OrderSystem/GetListOrderByPage",
     params
   });
 
   return res;
 };


 
export const GetOrdersOnlinePayment = async (params: any) => {
 
  const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).getH({
    url: "app/OrderSystem/GetOrdersOnlinePayment",
    params
  });
    
  return res;
};
  //客户生成订单
export const CreateShopOrder = async (params: any) => {
   
 const res = await (
  await superAxios.useWebAPI(OcelotService)
  ).post({
    url: "app/OrderSystem/CreateShopOrder",
    params,
  });
 return res;
  
};
 
//订单列表
export const GetListOrderByPage = async (params: any) => {
 
  const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).getH({
    url: "app/OrderSystem/GetListOrderByPage",
    params
  });
    
  return res;
};
//我的订单明细
export const GetOrderDetails = async (params: any) => {
 
  const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).getH({
    url: "app/OrderSystem/GetOrderDetails",
    params
  });
    
  return res;
};
 //创建退货单
export const CreateReturnOrder = async (params: any) => {
   
 const res = await (
  await superAxios.useWebAPI(OcelotService)
  ).post({
    url: "app/OrderSystem/CreateReturnOrder",
    params,
  });
 return res;
  
};
 //新增收货地址
export const CreateCustomerAddress = async (params: any) => {
   
 const res = await (
  await superAxios.useWebAPI(OcelotService)
  ).post({
    url: "app/OrderSystem/CreateCustomerAddress",
    params,
  });
 return res;
  
};

 //更新收货地址
export const UpdateCustomerAddress = async (params: any) => {
   
 const res = await (
  await superAxios.useWebAPI(OcelotService)
  ).put({
    url: "app/OrderSystem/UpdateCustomerAddress",
    params,
  });
 return res;
  
};
//删除收货地址
 export const DeleteCustomerAddress = async (params: any) => {
 
 
     var res = await (await superAxios.useWebAPI(OcelotService)).deleted({
             url: "app/OrderSystem/DeleteCustomerAddress",
             params
         })
     
    
  return res;
        };
 //设置收货地址默认值
export const SetCustomerAddressDefault = async (params: any) => {
   
 const res = await (
  await superAxios.useWebAPI(OcelotService)
  ).put({
    url: "app/OrderSystem/SetCustomerAddressDefault",
    params,
  });
 return res;
  
};

export const GetListCustomerAddress = async (params: any) => {
   
 const res = await (
  await superAxios.useWebAPI(OcelotService)
  ).get({
    url: "app/OrderSystem/GetListCustomerAddress",
    params,
  });
 return res;
  
};


  //取消订单
export const CustomerCancelOrder = async (params: any) => {
   
 const res = await (
  await superAxios.useWebAPI(OcelotService)
  ).post({
    url: "app/OrderSystem/CustomerCancelOrder",
    params,
  });
 return res;
  
};

